var websock = null;

var global_callback = null;
var userId = localStorage.getItem("userId")
  ? localStorage.getItem("userId")
  : "";
var wsuri =
  "wss://apibk.smartsketcher-ai.com/websocket/chat/message?userId=" + userId;

var lockReconnect = false;
var sendTimeoutObj = null;
var serverTimeoutObj = null;
var reconnectTimeoutObj = null;
var timeout = 60000; //心跳时间
var timeoutObj = null; //心跳对象
//  console.log('websock-uri',wsuri)
function createWebSocket(callback) {
  if (websock == null || typeof websock !== WebSocket) {
    initWebSocket(callback);
  }
}

function initWebSocket(callback) {
  global_callback = callback;
  // 初始化websocket
  websock = new WebSocket(wsuri);
  websock.onmessage = function(e) {
    websocketonmessage(e);
  };
  websock.onclose = function(e) {
    websocketclose(e);
  };
  websock.onopen = function() {
    websocketOpen();
  };

  // 连接发生错误的回调方法
  websock.onerror = function() {
    console.log("WebSocket连接发生错误");
    //createWebSocket();啊，发现这样写会创建多个连接，加延时也不行
    // 重新连接
    reconnect();
  };
}

// 实际调用的方法
function sendSock(agentData) {
  if (websock.readyState === websock.OPEN) {
    // 若是ws开启状态
    websocketsend(agentData);
  } else if (websock.readyState === websock.CONNECTING) {
    // 若是 正在开启状态，则等待1s后重新调用
    setTimeout(function() {
      sendSock(agentData);
    }, 1000);
  } else {
    // 若未开启 ，则等待1s后重新调用
    setTimeout(function() {
      sendSock(agentData);
    }, 1000);
  }
}

function closeSock() {
  lockReconnect = true;
  // 清理messagg.send定时器
  clearTimeout(sendTimeoutObj);
  // 清理服务器超时未响应定时器
  clearTimeout(serverTimeoutObj);
  // 清理重连定时器
  clearTimeout(reconnectTimeoutObj);
  sendTimeoutObj = null;
  serverTimeoutObj = null;
  reconnectTimeoutObj = null;
  websock.close();
}

// 数据接收
function websocketonmessage(msg) {
  // console.log("收到数据："+JSON.parse(e.data));
  // console.log("收到数据："+msg);

  // global_callback(JSON.parse(msg.data));

  // 收到信息为Blob类型时
  let result = null;
  // debugger
  if (msg.data instanceof Blob) {
    const reader = new FileReader();
    reader.readAsText(msg.data, "UTF-8");
    reader.onload = e => {
      result = JSON.parse(reader.result);
      //console.log("websocket收到", result);
      global_callback(result);
    };
  } else {
    result = JSON.parse(msg.data);
    //console.log("websocket收到", result);
    global_callback(result);
  }
  // heartCheckStart();
}

// 数据发送
function websocketsend(agentData) {
  console.log("发送数据：" + agentData);
  websock.send(agentData);
}

// 关闭
function websocketclose(e) {
  console.log("connection closed (" + e.code + ")");
  localStorage.setItem("websocketStatus", true)
  // 重新连接
  // reconnect();
}

function websocketOpen(e) {
  console.log("连接打开");
  // 心跳检测事件
  // heartCheckStart();
}
/**
 * 重置心跳监测
 */
// function reset() {
//   console.log(
//     "重置心跳监测---HeartBeat" + new Date().formatDate("yyyy-MM-dd hh:mm:ss")
//   );
//   clearTimeout(timeoutObj);
//   clearTimeout(serverTimeoutObj);
//   return 
// }
/**
 * 启动心跳监测
 */
function heartCheckStart() {
  console.log("心跳检测启动");
  timeoutObj = setTimeout(function() {
    //这里发送一个心跳，后端收到后，返回一个心跳消息，
    //onmessage拿到返回的心跳就说明连接正常
    var heartBeatJson = { messageType: "M4"};
    websocketsend(JSON.stringify(heartBeatJson));
    console.log(
      "发起心跳监测---HeartBeat" 
    );
    serverTimeoutObj = setTimeout(function() {
      //如果超过一定时间还没重置，说明后端主动断开了
      console.log(
        "心跳监测未重置,服务器断开->" +
          new Date().formatDate("yyyy-MM-dd hh:mm:ss")
      );
      websock.close(); //如果onclose会执行reconnect，我们执行ws.close()就行了.如果直接执行reconnect 会触发onclose导致重连两次
    }, timeout);
  }, timeout);
}
/**
 * 重新连接
 */
function reconnect() {
  // 若为手动关闭websocket，防止再次连接
  if (lockReconnect) return;
  console.log("重新连接~~~~~~~~~~");
  // 若websocket异常或者非法断开，两秒钟重连一次，直至重连成功
  reconnectTimeoutObj = setTimeout(() => {
    websock.close();
    // websocket进行连接
    // createWebSocket();
  }, 2000);
}
export { sendSock, createWebSocket, closeSock };



// WEBPACK FOOTER //
// ./src/until/socket.js